import axios from 'axios';

import { CreatePlan, Plan } from '@app-types/service.type';
import { buildEndpoint, getAuthToken } from '@services/service';

const BASE_SUBSCRIPTIONS_URL = process.env
    .REACT_APP_SUBSCRIPTIONS_URL as string;

type RequestPayload = CreatePlan & { serviceId: number };

const createPlan = async (data: RequestPayload): Promise<Plan | null> => {
    try {
        const endpoint = buildEndpoint(
            BASE_SUBSCRIPTIONS_URL,
            `/api/admin/plans`
        );
        const response = await axios.post(endpoint, data, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data;
    } catch (err) {
        console.error('Error creating plan:', err);
        return null;
    }
};

export { createPlan };
